import { render } from "./tableProfPresenca02.vue?vue&type=template&id=d63ad372&scoped=true"
import script from "./tableProfPresenca02.vue?vue&type=script&lang=js"
export * from "./tableProfPresenca02.vue?vue&type=script&lang=js"

import "./tableProfPresenca02.vue?vue&type=style&index=0&id=d63ad372&lang=scss&scoped=true"
import "./tableProfPresenca02.vue?vue&type=style&index=1&id=d63ad372&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d63ad372"]])

export default __exports__